import getConfig from 'next/config';
import Cookie from 'universal-cookie';

const { publicRuntimeConfig: { environmentalizedDomains, cookieName } } = getConfig();
const defaultDomain = environmentalizedDomains[Object.keys(environmentalizedDomains)[0]];

const getCookieHost = () => {
  const cookie = new Cookie();
  const siteCookie = cookie.get(cookieName);

  return siteCookie?.host;
};

// see https://developer.mozilla.org/en-US/docs/Web/API/URL for more detailed information
export default function urlHelper(urlString = '', domain = null, ssl = false) {
  const domainToUse = domain || getCookieHost() || defaultDomain;
  const url = new URL(urlString, domainToUse);
  url.protocol = url.hostname === "localhost" && !ssl ? "http:" : "https:";

  return url;
}
